module.exports = __webpack_public_path__ + "static/media/congaHi.a552d4bf.wav";